import { registerDashboardWidget, setDashboardWidgetLayout } from '@vendure/admin-ui/core';

export default [
    registerDashboardWidget('app-downloads', {
        title: 'App Downloads',
        supportedWidths: [12],
        loadComponent: () =>
            import('./app-downloads.component').then(
                m => m.AppDownloadsWidgetComponent
            ),
    }),
];